import axios from './categoryInstance'

const updateCategoryImagesByName = async (images: string[], categoryId: string) => {
  const payload = {
    operation: "update",
    values:{
      "image_ids": images
    }
  }
  
  const response: any = await axios.patch(`/categories/${categoryId}`, payload)
  return response.data
}

export default updateCategoryImagesByName
